import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ss-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
  standalone: false
})
export class ToggleButtonComponent implements OnInit {
  @Input() nameLabelOne!: string;
  @Input() idLabelOne!: number;
  @Input() nameLabelTwo!: string;
  @Input() idLabelTwo!: number;
  @Input() labelOne!: string;
  @Input() labelTwo!: string;
  @Input() checked!: boolean;
  @Output() toggleClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  activeLabel!: string;

  constructor() { }

  ngOnInit() {
    this.activeLabel = this.checked ? this.labelTwo : this.labelOne;
  }

  onToggleClick(label: string) {
    if (this.activeLabel !== label) {
      this.activeLabel = label;
      this.toggleClicked.emit(label === this.labelOne);
    }
  }
}
